.toInputContainer {
  width: 100%;
  box-sizing: border-box;
  padding: 7px 12px 9px 7px;
  border: solid 1px;
  border-radius: 12px;
  min-height: 50px;
  max-height: 300px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;

  @include themify($themes) {
    border-color: themed("neutral-secondary") !important;
    background-color: themed("main-secondary") !important;
    
  }
  
  .toInput {
    border: none;
    font-size: 14px;
    font-weight: 500;
    margin: auto 0;
    width: 100%;
    min-width: 120px;
    flex: 1;

    @include themify($themes) {
      background-color: themed("main-secondary") !important;
      color: themed("main-primary") !important
    }
  }

  .toInput:focus {
    outline: none;
  }
}
.singleInputItem {
  display: flex;
  height: 34px;
  padding: 0 10px 0 12px;
  border-radius: 12px;
  font-size: 14px;
  @include themify($themes) {
    background-color: themed("neutral-tertiary");
  }
  
  .singleInputText {
    margin: auto 7px auto 0;
  }
  
  .singleInputItemDeleteIcon {
    cursor: pointer;
    margin: auto;
    @include themify($themes) {
      color: themed("neutral-primary") !important;
    }
  }
}

